<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.TheInspectionProcessImg') " alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.customer") }} </div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
                  <li>          <router-link to="/CustomerInspection">
                    <div>{{ $t("menu.Instructions") }}</div></router-link>
                  </li> 
              </div>
            </template>

            <template #ContentSan>
              <div class="inlineer">
                <li>
                  <router-link to="/TestApplicationForm">
                    <div>{{ $t("menu.Testapplicationform") }}</div></router-link >
                </li>
              </div>
            </template>
            <template #ContentSi>
              <div class="inlineer">
                <li>
                  <router-link to="/TheReportQuery"
                    ><div>{{ $t("menu.TheReportQuery") }}</div></router-link
                  >
                </li>
              </div>
            </template>
            <template #ContentWu>
              <div class="inlineer">
                <li>
                  <router-link to="/TheInspectionProcess">
                    <div style="color: #1d2088">{{ $t("menu.TheInspectionProcess") }} </div></router-link
                  >
                </li>
              </div>
            </template>
          </Content>
        </el-col>
      
        <el-col :span="17">
          <div class="inline">
            
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{ $t("menu.TheInspectionProcess") }} </h3>
          </div>
       
        
          <div class="fff">
            <el-row>
              <el-col :span="24">
                <el-image :src="imageUrl" alt="" style="margin-bottom:20px"></el-image>
              </el-col>
            </el-row>
            <div v-for="(item,index) in SelectList" :key="index">
                <el-row style="width:78%">
          
                  <el-col :span="24">
                      <p v-html="item.details" >
                </p>
                  </el-col>
                </el-row>

            </div>
          </div>
        </el-col>
    
      </el-row>
    </div>
    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>

  
<style scoped>
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.img {
  margin-right: 15px;
  margin-left: 5px;
}
.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  padding-top: 0px;
}
span {
  font-size: 16px;

  color: #333333;
}
p {
  color: #666666;
  font-size: 12px;
  margin: 5px 0px;
}
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}
</style>

<script>
export default {
  name: "TheInspectionProcess",

  data() {
    return {
      number: "5-4",
          SelectList: [],
      title: "",
      imageUrl:""
    };
  },
    created: function () {
    //  console.log(this.$i18n.locale)
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    //  console.log(this.title)
    this.getSelect();
  },
  methods: { 
    async getSelect() {
      console.log(this.title);
      const { data: res } = await this.$http.get("/Service/GetProcessInfo", {
        params: { languageType: this.title },
      });

      if (res.code !== 200) return console.log("数据请求失败! ");
      this.SelectList = res.data.step;
      this.imageUrl=res.data.imageUrl;
      // console.log(this.SelectList);
    },
  },
};
</script>